import React from 'react';
import bg from '../assets/GIThome.png';
import { BsPerson, BsTelephone } from "react-icons/bs";
import { MdOutlineMail } from "react-icons/md";
import { FiBook } from "react-icons/fi";
import { FaRegComment } from "react-icons/fa6";

const GetInTouchHome = () => {
  return (
    <div className='relative w-full h-auto mb-24'>
      <div className='absolute inset-0 z-0'>
        <img className='w-full h-full object-cover' src={bg} alt='get in touch' />
      </div>

      <div className='relative z-10 px-4 py-8 lg:px-32'>
        <p className='text-[#EBEBEB] text-[28px] sm:text-[36px] md:text-[40px] font-semibold leading-[36px] mb-6'>
          Get In Touch!
        </p>

        <form className='w-full max-w-[736px] bg-white p-6 md:p-10 rounded-[12px] shadow-[0px_4px_4px_0px_#00000040] flex flex-col gap-6'>

          {/* Row 1 */}
          <div className='flex flex-col md:flex-row gap-6'>
            <div className='w-full'>
              <label className='text-sm font-bold'>
                Your Name <span className='text-[#E43F52]'>*</span>
              </label>
              <div className='relative mt-2'>
                <span className='absolute inset-y-0 left-0 flex items-center pl-3'>
                  <BsPerson className='text-xl' />
                </span>
                <input
                  type='text'
                  placeholder='Your Name:'
                  className='w-full border-2 border-[#DEE2E6] py-2 pl-10 pr-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
                />
              </div>
            </div>

            <div className='w-full'>
              <label className='text-sm font-bold'>
                Your Mobile <span className='text-[#E43F52]'>*</span>
              </label>
              <div className='relative mt-2'>
                <span className='absolute inset-y-0 left-0 flex items-center pl-3'>
                  <BsTelephone className='text-lg' />
                </span>
                <input
                  type='tel'
                  placeholder='Your Mobile:'
                  className='w-full border-2 border-[#DEE2E6] py-2 pl-10 pr-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
                />
              </div>
            </div>
          </div>

          {/* Row 2 */}
          <div className='w-full'>
            <label className='text-sm font-bold'>
              Your Email <span className='text-[#E43F52]'>*</span>
            </label>
            <div className='relative mt-2'>
              <span className='absolute inset-y-0 left-0 flex items-center pl-3'>
                <MdOutlineMail className='text-xl' />
              </span>
              <input
                type='email'
                placeholder='Your Email:'
                className='w-full border-2 border-[#DEE2E6] py-2 pl-10 pr-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
              />
            </div>
          </div>

          {/* Row 3 */}
          <div className='w-full'>
            <label className='text-sm font-bold'>Subject</label>
            <div className='relative mt-2'>
              <span className='absolute inset-y-0 left-0 flex items-center pl-3'>
                <FiBook className='text-lg' />
              </span>
              <input
                type='text'
                placeholder='Subject'
                className='w-full border-2 border-[#DEE2E6] py-2 pl-10 pr-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
              />
            </div>
          </div>

          {/* Row 4 */}
          <div className='w-full'>
            <label className='text-sm font-bold'>Comments</label>
            <div className='relative mt-2'>
              <span className='absolute top-3 left-0 pl-3'>
                <FaRegComment className='text-lg' />
              </span>
              <textarea
                rows='4'
                placeholder='Your message...'
                className='w-full border-2 border-[#DEE2E6] py-2 pl-10 pr-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
              />
            </div>
          </div>

          {/* Button */}
          <button className='bg-[#0058AE] text-white py-2 rounded-md text-center hover:bg-[#004c99] transition-all duration-200'>
            Send
          </button>
        </form>
      </div>
    </div>
  );
};

export default GetInTouchHome;
